import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/articles';

export default function HotTopics() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 340;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="flex items-end justify-between mb-6 md:mb-8">
            <div>
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-900 flex items-center gap-3">
                <span className="text-primary-500">热点</span>
                速览
                <span className="inline-block w-2 h-2 rounded-full bg-accent-500 ml-1 animate-pulse"></span>
              </h2>
              <p className="text-sm text-foreground-500 mt-1">实时追踪最新娱乐八卦与网红爆料</p>
            </div>
            <span className="hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
              <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center"></i>
              实时更新中
            </span>
          </div>

          {/* Scrollable Cards */}
          <div className="relative">
            {/* Left Arrow */}
            <button
              onClick={() => scroll('left')}
              className="absolute -left-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-background-50 border border-background-300 flex items-center justify-center text-foreground-600 hover:text-foreground-900 hover:border-foreground-400 transition-all hidden md:flex cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </button>

            {/* Cards */}
            <div
              ref={scrollRef}
              className="flex gap-4 md:gap-5 overflow-x-auto scrollbar-hide pb-2"
            >
              {hotArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="flex-shrink-0 w-[280px] md:w-[320px] group"
                >
                  <div className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300">
                    {/* Image */}
                    <div className="relative aspect-[4/3] overflow-hidden">
                      <img
                        src={article.imageUrl}
                        alt={article.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="text-xs px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 font-medium">
                          {article.category}
                        </span>
                      </div>
                    </div>
                    {/* Info */}
                    <div className="p-4">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h3>
                      <div className="flex items-center justify-between mt-3">
                        <span className="text-xs text-foreground-500">{article.publishDate}</span>
                        <span className="flex items-center gap-1 text-xs text-accent-600 font-semibold">
                          <i className="ri-fire-line w-3 h-3 flex items-center justify-center"></i>
                          {article.hotValue.toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* Right Arrow */}
            <button
              onClick={() => scroll('right')}
              className="absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-foreground-900 text-background-50 flex items-center justify-center hover:bg-foreground-800 transition-all hidden md:flex cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}